import BaseApiService from './BaseApiService'

export const NotificationType = { STANDARD: 10, WARNING: 20, ANNOUNCEMENT: 30 } as const

export interface Notification {
  notificationId: string
  type: number
  title: string
  body: string | null
  createdAt: string
  readAt: string | null
}

export interface NotificationList {
  items: Notification[]
  unread: number
}

export interface SendNotificationPayload {
  type: number
  title: string
  body: string | null
  teamId: string | null
  group: string | null
  userIds: string[] | null
  sendEmail: boolean
}

class NotificationsApiService extends BaseApiService {
  /** Bell contents + unread count. silent so polling never bounces the user to /login. */
  list(): Promise<NotificationList> {
    return this.postSilent<NotificationList>('/v1/notifications/list')
  }

  /** Unread warning/announcement notifications to show in a modal. */
  unreadModal(): Promise<Notification[]> {
    return this.postSilent<Notification[]>('/v1/notifications/unread-modal')
  }

  markRead(notificationId: string): Promise<void> {
    return this.post<void>('/v1/notifications/mark-read', { notificationId })
  }

  markAllRead(): Promise<void> {
    return this.post<void>('/v1/notifications/mark-all-read')
  }

  /** Admin: send a notification to a group and/or explicit users, optionally by email too. */
  send(payload: SendNotificationPayload): Promise<{ sent: number }> {
    return this.post<{ sent: number }>('/v1/admin/send-notification', payload)
  }
}

export const notificationsApiService = new NotificationsApiService()
